import { FlowType } from '@vfde-sails/constants/dist/types/miscellaneous';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import {
    FLOW_DEVICE_FIRST,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_FLOW_TYPE,
} from '@vfde-sails/constants';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get flow type from storage or return default for this page
 */
export const getFlowTypeFromStorage = (): FlowType => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    return storage?.[SAILS_PARAM_FLOW_TYPE] || FLOW_DEVICE_FIRST;
};
